// puppygirl shopify theme — js

(function () {
  'use strict';

  // ── star field ─────────────────────────────────────────────
  function initStars() {
    const field = document.getElementById('star-field');
    if (!field) return;
    const types = ['', '--amber', '--pink'];
    for (let i = 0; i < 55; i++) {
      const s = document.createElement('div');
      s.className = 'star' + (types[Math.floor(Math.random() * types.length)] ? ' star' + types[Math.floor(Math.random() * types.length)] : '');
      s.style.cssText = `left:${Math.random()*100}%;top:${Math.random()*100}%;--dur:${2+Math.random()*5}s;--delay:${Math.random()*5}s`;
      field.appendChild(s);
    }
  }

  // ── mobile nav toggle ──────────────────────────────────────
  function initNav() {
    const btn = document.querySelector('.nav-toggle');
    const nav = document.getElementById('primary-nav');
    if (!btn || !nav) return;
    btn.addEventListener('click', () => {
      const open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', !open);
      nav.classList.toggle('is-open', !open);
    });
  }

  // ── variant selector ───────────────────────────────────────
  function initVariants() {
    const form = document.querySelector('form[action="/cart/add"]');
    if (!form) return;

    form.querySelectorAll('.variant-btns').forEach((group, groupIndex) => {
      const btns = group.querySelectorAll('.variant-btn');
      btns.forEach(btn => {
        btn.addEventListener('click', () => {
          btns.forEach(b => b.classList.remove('is-selected'));
          btn.classList.add('is-selected');

          // update size label if present
          const optionIndex = parseInt(group.dataset.optionIndex ?? groupIndex);
          const labelSpan = group.closest('.product-options')?.querySelector('.product-options__label span');
          if (labelSpan) labelSpan.textContent = btn.dataset.value;

          updateActiveVariant(form);
        });
      });
    });
  }

  function updateActiveVariant(form) {
    if (!form) form = document.querySelector('form[action="/cart/add"]');
    if (!form) return;

    const variantSelect = form.querySelector('select[name="id"]');
    if (!variantSelect) return;

    // collect current selections in order
    const selectedValues = Array.from(form.querySelectorAll('.variant-btns')).map(group => {
      const sel = group.querySelector('.is-selected');
      return sel ? sel.dataset.value : '';
    });

    // find matching variant option using JSON data attribute
    let matched = false;
    Array.from(variantSelect.options).forEach(opt => {
      try {
        const optValues = JSON.parse(opt.dataset.options || '[]');
        if (JSON.stringify(optValues) === JSON.stringify(selectedValues)) {
          variantSelect.value = opt.value;
          // sync hidden input too
          const hiddenId = form.querySelector('input[name="id"]');
          if (hiddenId) hiddenId.value = opt.value;
          // update price display
          const priceEl = document.getElementById('product-price');
          if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;
          // always keep add-to-cart enabled for POD
          const addBtn = form.querySelector('.btn--add-to-cart');
          if (addBtn) { addBtn.disabled = false; addBtn.textContent = '◈ add to cart'; }
          matched = true;
        }
      } catch (e) {}
    });

    // if no exact match found, still enable the button (POD handles fulfillment)
    if (!matched) {
      const addBtn = form.querySelector('.btn--add-to-cart');
      if (addBtn) addBtn.disabled = false;
    }
  }

  // ── qty controls ───────────────────────────────────────────
  function initQty() {
    document.querySelectorAll('.qty-wrap').forEach(wrap => {
      const input = wrap.querySelector('.qty-input');
      wrap.querySelector('.qty-btn[data-dir="-1"]')?.addEventListener('click', () => {
        const v = parseInt(input.value) || 1;
        if (v > 1) input.value = v - 1;
      });
      wrap.querySelector('.qty-btn[data-dir="1"]')?.addEventListener('click', () => {
        input.value = (parseInt(input.value) || 1) + 1;
      });
    });
  }

  // ── product image thumbnails ───────────────────────────────
  function initThumbs() {
    const thumbs = document.querySelectorAll('.product-media__thumb');
    const main = document.querySelector('.product-media__main img');
    if (!thumbs.length || !main) return;
    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        thumbs.forEach(t => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
        const src = thumb.dataset.src;
        if (src) {
          main.src = src;
          main.srcset = '';
        }
      });
    });
  }

  // ── add to cart feedback ───────────────────────────────────
  function initCartBtn() {
    const form = document.querySelector('form[action="/cart/add"]');
    if (!form) return;
    const btn = form.querySelector('.btn--add-to-cart');
    if (!btn) return;
    const origText = btn.textContent;
    form.addEventListener('submit', function(e) {
      // let Shopify handle the actual submission
      // just provide UI feedback
      btn.disabled = true;
      btn.textContent = '✦ adding...';
      setTimeout(() => {
        btn.disabled = false;
        btn.textContent = '✓ added to cart';
        updateCartCount();
        setTimeout(() => { btn.textContent = origText; }, 2000);
      }, 800);
    });
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        document.querySelectorAll('.cart-count').forEach(el => {
          el.textContent = cart.item_count;
          el.dataset.count = cart.item_count;
        });
      });
  }

  // ── cart qty update ────────────────────────────────────────
  function initCartQty() {
    document.querySelectorAll('.cart-item__qty-btn').forEach(btn => {
      btn.addEventListener('click', function() {
        const key = this.dataset.key;
        const dir = parseInt(this.dataset.dir);
        const countEl = this.closest('.cart-item__qty').querySelector('.cart-item__qty-count');
        const current = parseInt(countEl.textContent) || 1;
        const newQty = Math.max(0, current + dir);
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: newQty })
        })
        .then(r => r.json())
        .then(() => window.location.reload());
      });
    });
  }

  // ── init ───────────────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', () => {
    initStars();
    initNav();
    initVariants();
    initQty();
    initThumbs();
    initCartBtn();
    initCartQty();
    updateCartCount();
  });

})();
